import * as actionTypes from '../actions/actionTypes';

const initialState = {
    language: localStorage.getItem("lang") ? JSON.parse(localStorage.getItem("lang")) : {code: 'ru', name: 'Русский'},
    availableLanguages: [
        {
            code: 'ru',
            name: 'Русский',
        },
        {
            code: 'en',
            name: 'English'
        }
    ],
    theme: localStorage.getItem("theme") ? JSON.parse(localStorage.getItem("theme")) : 'light',
    ifServerUnavailable: false,
};

const setLanguage = (state, action) => {
    return {
        ...state,
        language: {...action.language}
    }
}

const setTheme = (state, action) => {
    return {
        ...state,
        theme: action.theme
    }
}

const setServerError = (state, action) => {
    return {
        ...state,
        ifServerUnavailable: action.ifServerUnavailable
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_LANGUAGE: return setLanguage( state, action );
        case actionTypes.SET_THEME: return setTheme( state, action );
        case actionTypes.SET_SERVER_UNAVAILABLE: return setServerError( state, action );
        default: return state;
    }
};
export default reducer;